import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faTrash, faPen } from '@fortawesome/free-solid-svg-icons';
import AddTrackLimits from '../TrackLimits/AddTrackLimits';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import { CallBackAlert } from '../Common/Validations/validation';
import DataTable from '../Common/DataTableList';
import moment from 'moment';

const TrackLimits = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [displayAddTrackLimits, setdisplayAddTrackLimits] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [TrackLimitEditData, setTrackLimitEditData] = useState([]);
    const [TrackLimitsData, setTrackLimitsData] = useState([]);
    const [FilterTrackLimits, setFilterTrackLimits] = useState([]);
    const [Organization, setOrganization] = useState([]);

    useEffect(() => {
        FetchTrackLimits();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns = [
        {
            name: 'Active',
            selector: row => { return <div style={{ marginLeft: "15px" }} className={row.IsDeleted ? "InActiveDiv" : "ActiveDiv"}></div> },
        },
        {
            name: 'Partner',
            wrap: true,
            grow: 2,
            selector: (row) => {
                return row.Organization && row.Organization.length > 0 ? (<div>
                    <div>{`MFI ${row.Organization[0].City}`}</div>
                    <div>{row.Organization[0].Name}</div>
                </div>) : <span>-</span>

            },
            sortable: true,
        },
        {
            name: 'New Limit',
            wrap: true,
            selector: row => row.LimitCount,
            sortable: true,
        },
        {
            name: 'Added Limit',
            wrap: true,
            selector: row => row.AddedLimit,
            sortable: true,
        },
        {
            name: 'Last Updated',
            wrap: true,
            selector: row => moment(row.updatedAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Remarks',
            wrap: true,
            grow: 2,
            selector: row => row.Remarks,
            sortable: true,
        },
        {
            name: 'Created Date',
            wrap: true,
            selector: row => moment(row.createdAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Action',
            width: "150px",
            selector: (row) => {
                return (
                    <div>
                        <span className="cursorpointer" style={{ color: "#147a6f", marginLeft: "15px" }} title="Edit" onClick={() => EditSelectedTrackLimit(row)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faPen} /></span>
                        <span className="cursorpointer" style={{ color: "#f61414", marginLeft: "15px" }} title="Delete" onClick={() => DeleteSelectedTrackLimit(row._id)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faTrash} /></span>
                    </div>
                )
            }
        }
    ];

    const onTrackLimitsSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = TrackLimitsData.filter(c => (c.Organization && c.Organization.length > 0 &&
                c.Organization[0].Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase())) ||
                (c.Organization && c.Organization.length > 0 &&
                    c.Organization[0].City.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterTrackLimits(userSearchData);
        }
        else {
            setFilterTrackLimits(TrackLimitsData);
        }
    };

    const FetchTrackLimits = () => {
        Axiosfetch(baseURL + "GetActiveTrackLimits", "GET", null, TrackLimitsuccess, Failure);
    };

    const TrackLimitsuccess = (data) => {
        setTrackLimitsData(data);
        setFilterTrackLimits(data);
        FetchOrganization();
    };

    const FetchOrganization = () => {
        Axiosfetch(baseURL + "GetActiveOrganizations", "GET", null, UserOrgSuccess, Failure);
    }

    const UserOrgSuccess = (data) => {
        if (data.length > 0) {
            var dropList = [];
            data.map(org => {
                dropList.push({ value: org._id, label: org.Name });
            });

            setOrganization(dropList);
        }
        else {
            setOrganization([]);
        }
    };

    const showTrackLimits = () => {
        setdisplayAddTrackLimits("block");
        setIsEdit(0);
    };

    const EditSelectedTrackLimit = (TrackLimitDetails) => {
        setTrackLimitEditData(TrackLimitDetails);
        setIsEdit(1);
        setdisplayAddTrackLimits("block");
    };

    const hideTrackLimit = () => {
        setdisplayAddTrackLimits("none");
    };

    const DeleteSelectedTrackLimit = (TrackLimitID) => {
        Axiosfetch(baseURL + "DeleteTrackLimit", "POST", { _id: TrackLimitID }, TrackLimitDeleteSuccess, Failure);
    };

    const TrackLimitDeleteSuccess = (data) => {
        FetchTrackLimits();

        CallBackAlert(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right trackheader" style={{ fontWeight: "500" }}>Tracking Limits</h5>
                    </div>
                    <div className="offset-md-2 col-md-3 col-sm-6 col-10" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search Partner..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onTrackLimitsSearch(e.target.value)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-2 col-2 align-left">
                        <span data-tip="Add User" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showTrackLimits}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
                        <DataTable
                            columns={columns}
                            data={FilterTrackLimits}
                        />
                    </div>
                </div>
                {displayAddTrackLimits === "block" && <AddTrackLimits themeColor={CurrentTheme} hideTrackLimit={hideTrackLimit} getTrackLimit={FetchTrackLimits} edit={IsEdit} TrackLimitdetail={TrackLimitEditData} Organization={Organization}></AddTrackLimits>}
            </div>
        </div>
    );
};

export default TrackLimits;